const PhaseType = {
  GET_PHASES: 'GET_PHASES',
  GET_PHASE: 'GET_PHASE',
  CREATE_PHASE: 'CRAETE_PHASE',
  UPDATE_PHASE: 'UPDATE_PHASE',
  DELETE_PHASE: 'DELETE_PHASE',
}

export default PhaseType
